<template>
    <div id="app">
        <el-container>
            <el-main style="background: #f4f4f4" class="input2qiangzhi_buxudong111_style">
                <div class="contain">
                    <el-divider class="main_hr"></el-divider>
                </div>
                <!-- 视频 -->
                <el-row>
                    <el-col :xs="24" :sm="24" :md="24">
                        <div class="main_xiangqing">
                            <div class="xiangqing_back" v-if="type===0">
                                <div style="width: 92%;margin-left: 4%;margin-bottom: 50px;margin-top: 30px">
                                    <!--                {{ data_list.info }}-->
                                    <div v-if="data_list.created_at" class="wenzhang_time">
                                        {{data_list.created_at.slice(0,10)}}
                                    </div>
                                    <div clas="title" style="text-align:center;font-size: 16px;font-weight: bold;"> {{data_list.info.title}}</div>
                                    <div id="html-content" v-html="wenzhang_neirong"
                                         style="border: black solid 1px;padding: 20px;min-height: 300px"></div>
                                </div>
                                <!-- 这里展示 视频 -->
                                <div v-if="data_list.info.video" >
                                    <div style="margin-left:4%;line-height:2">视频展示</div>
                                    <div>
                                        <video :src="data_list.info.video_url" controls style="width:92%; height:auto; margin-left:4%;" ></video>
                                    </div>
                                    
                                </div>

                                <!-- 这里展示 附件 -->
                                <div v-if="data_list.info.attachment" >
                                    <div style="width:92%;margin-left:4%; margin-top:20px;">附件: <a :href="data_list.info.attachment_url">{{ data_list.info.attachment_url }}</a></div>
                                </div>

                            </div>
                            <div class="xiangqing_back" v-if="type===3">
                                <div style="width: 92%;margin-left: 4%;margin-bottom: 50px;margin-top: 30px">
                                    <!--                {{ data_list.info }}-->
                                    <div v-if="data_list.created_at" class="wenzhang_time">
                                        {{data_list.created_at.slice(0,10)}}
                                    </div>
                                    <div style="text-align:center"> {{data_list.title}}</div>
                                    <div class="jieshao_neirong ">
                                        <div class="html-content"  v-html="wenzhang_neirong"></div>
                                    </div>
                                    <div class="back_jieshaoa">
                                        <a :href="'/home.html#/shops/index/'+data_list.info.shop_id">
                                            <span class="jieshao_fabua">发布者：</span>
                                            <span class="jieshao_namea">{{ data_list.info.shop.shop_name }}</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="xiangqing_back" v-if="type===1">
                                <!--                {{data_list}}-->
                                <div class="back_xinxikuang">
                                    <div style="float: left">
                                        <img class="xinxikuang_img" :src="url_dizhi+'/storage/'+data_list.info.pic">
                                    </div>
                                    <div style="float: left">
                                        <div class="xinxikuang_text">{{data_list.info.title}}</div>
                                        <div class="xinxikuang_liulan">
                                            下载次数：{{ data_list.info.download_count }}
                                        </div>
                                        <div class="xinxikuang_liulan">
                                            浏览次数：{{ data_list.info.view_count }}
                                        </div>
                                        <div class="xinxikuang_liulan">
                                            关键词：{{ data_list.info.keywords }}
                                        </div>
                                        <div class="xinxikuang_liulan">
                                            应用领域：{{ data_list.info.category.title}}
                                        </div>
                                    </div>
                                </div>
                                <!--                <div v-for="(item,index) in yingyongly" v-bind:key="index">-->
                                <!--                  {{item}}-->
                                <!--                </div>-->
                                <div class="back_jieshao">
                                    <a :href="'/home.html#/shops/index/'+data_list.info.shop_id"><span
                                            class="jieshao_fabu">发布者：</span>
                                        <span class="jieshao_name">{{ data_list.info.shop.shop_name }}</span>
                                    </a>
                                    <span class="jieshao_time hidden-xs-only">发布时间：  {{ data_list.info.updated_at }}</span>
                                    <div class="jieshao_neirong ">
                                        <div class="html-content"  v-html="wenzhang_neirong"></div>11
                                    </div>
                                    <div style="width: 100%;height: 50px"></div>

                                    <div class="jieshao_caozuo">
                                        <div class="hidden-sm-and-down">
                                            <div class="jieshao_cash">
                                                <img class="cash_img" src="../../../assets/home/college/cash.png">
                                                <div class="cash_text">价格：{{ data_list.info.price }}元</div>
                                            </div>
                                            <!--                    <a :href="url_dizhi+'/storage/'+data_list.info.file">-->
                                            <a @click="yyfa_download">
                                                <div class="caozou_xiazai">
                                                    <img class="xiazai_img"
                                                         src="../../../assets/home/college/xiazi.png">
                                                    <div class="xiazai_text">下载</div>
                                                </div>
                                            </a>
                                        </div>
                                        <div class="hidden-sm-and-up" style="text-align: center;">
                                            <div class="jieshao_cash"
                                                 style="text-align: center;margin: 10px auto;float:none;">
                                                <img class="cash_img" src="../../../assets/home/college/cash.png">
                                                <div class="cash_text">价格：{{ data_list.info.price }}元</div>
                                            </div>
                                            <a :href="url_dizhi+'/storage/'+data_list.info.file">
                                                <div class="caozou_xiazai"
                                                     style="text-align: center;margin: 10px auto;float:none;">
                                                    <img class="xiazai_img"
                                                         src="../../../assets/home/college/xiazi.png">
                                                    <div class="xiazai_text">下载</div>
                                                </div>
                                            </a>
                                        </div>
                                        <div style="width: 100%;height: 70px;float: left"></div>
                                    </div>
                                </div>

                            </div>
                            <div class="xiangqing_back2" v-if="type===2">
                                <!--                                {{data_list}}-->
                                <div class="back_text">{{data_list.info.title}}</div>
                                <div class="back_text2">
                                    <a :href="'/home.html#/shops/index/'+data_list.info.shop_id">
                                        <span class="text2_biaoti">发布人：</span>

                                        <span class="text2_neirong">{{data_list.info.shop.shop_name}}</span>
                                    </a>
                                </div>
                                <div class="back_text3">发布时间： {{ data_list.info.updated_at }}</div>
                                <!--                <div class="back_button  hidden-sm-and-up">-->
                                <!--                  <a :href="url_dizhi+'/storage/'+data_list.info.file">-->
                                <!--                    &lt;!&ndash;                  <a :href="url_dizhi+'/storage/'+data_list.info.file">&ndash;&gt;-->
                                <!--                    <div class="button_zaixian" style="text-align: center;margin: 10px auto;float:none;">在线浏览</div>-->
                                <!--                  </a>-->
                                <!--                  <a :href="url_dizhi+'/storage/'+data_list.info.file">-->
                                <!--                    <div class="button_xiazai" style="text-align: center;margin: 10px auto;float:none;">下载</div>-->
                                <!--                  </a>-->
                                <!--                </div>-->
                                <div class="back_button hidden-sm-and-down">
                                    <!--                  <a :href="url_dizhi+'/storage/'+data_list.attachment[0].url">-->
                                    <!--                    <div class="button_zaixian">在线浏览</div>-->
                                    <!--                  </a>-->
                                    <a :href="url_yulan+url_dizhi+'/storage/'+data_list.attachment[0].url"
                                       target="_blank"
                                       rel="nofollow"
                                       v-if="wzlx == 'docx'"
                                    >
                                        <div class="button_zaixian">
                                            在线浏览
                                        </div>
                                    </a>
                                    <a :href="url_dizhi+'/storage/'+data_list.attachment[0].url" v-else target="_blank"
                                       rel="nofollow">
                                        <div class="button_zaixian">
                                            在线浏览
                                        </div>
                                    </a>
                                    <a :href="url_dizhi+'/storage/'+data_list.attachment[0].url" download="w3logo">
                                        <div class="button_xiazai">下载</div>
                                    </a>
                                </div>
                                <div class="fenge"></div>
                                <div style="position: absolute;margin-top: 110px;margin-left: 100px;width:900px;margin-right: 90px">
                                    <div class="html-content"  v-html="wenzhang_neirong"></div>
                                </div>
                            </div>
                            <div style="width: 100%;height: 200px;float: left"></div>
                        </div>
                    </el-col>
                </el-row>
            </el-main>
        </el-container>
    </div>
</template>
<script>

    export default {
        name: "category",
        data: function () {
            return {
                input: '',
                type: 0,
                data_list: '',
                wenzhang_neirong: '',
                filter: {
                    article_type: '',
                    title: '',
                    sort: 'date',
                    sousuo: '',
                },
                pailie: [
                    {zhuangtai: 1, name: '最新'}, {zhuangtai: 0, name: '最热'}
                ],
                anniuzhuangtai: 1,
                article_list: [],
                sousuoshuju: [],
                leixingqingqiu: [],
                leixingzhi: '',
                paixunshangchuan: '',
                paixunzhuangtai: '',
                url_dizhi: '',
                url_yulan: '',
                wzlx: ''
            }
        },
        components: {},
        methods: {
            init: function () {
                var t = this
                this.url_dizhi = window.config.api_url;
                console.log(window.config.api_url)
                this.url_yulan = 'https://view.officeapps.live.com/op/view.aspx?src=';
                if (this.$route.params.article_type) {
                    this.filter.article_type = this.$route.params.article_type;
                }
                if (this.$route.params.sousuo) {
                    this.filter.sousuo = this.$route.params.sousuo;
                }
                console.log(this.$route.path.slice(0, 14))
                if (t.$route.path.slice(0, 14) == '/college/video') {
                    t.yicaixiu_list()
                    t.type = 3
                }
                if (t.$route.path.slice(0, 14) == '/college/categ') {
                    t.wenzhang_list()
                    t.type = 0
                }
                if (t.$route.path.slice(0, 14) == '/college/progr') {
                    t.fangan_list()
                    t.type = 1
                }
                if (t.$route.path.slice(0, 14) == '/college/stand') {
                    t.biaozhun_list()
                    t.type = 2
                }
                // this.search();
                // this.sousuozhi();
                // console.log(this.$route.params.sousuo);
                // this.wenzhangleixing_api();
            },
            wenzhangleixing_api() {
                var t = this
                this.axios
                    .get(window.config.api_url + '/college/article/type')
                    .then(function (res) {
                        t.leixingqingqiu = res.data
                        // console.log(  t.leixingqingqiu )
                    });
            },
            yicaixiu_list() {
                var t = this
                console.log('---------')
                var url = window.config.api_url + '/college/video/' + t.$route.params.id
                t.axios.get(url).then(res => {
                    t.data_list = res.data
                    console.log("66656", res.data);
                    var html_content = res.data.info.description;
                    html_content = html_content.replace(/(<img .*?src=)"\/(.*?)"/g, '$1"' + window.config.yihai_site + '/$2"');
                    html_content = html_content.replace(/(<source .*?src=)"\/(.*?)"/g, '$1"' + window.config.api_url + '/$2"');
                    html_content = html_content.replace(/(<video .*?src=)"\/(.*?)"/g, '$1"' + window.config.api_url + '/$2"');
                    t.wenzhang_neirong = html_content;
                })
            },
            wenzhang_list() {
                var t = this
                var url = window.config.api_url + '/college/article/' + t.$route.params.id
                t.axios.get(url).then(res => {
                    t.data_list = res.data
                    console.log("121", res.data);
                    var html_content = res.data.info.content;
                    html_content = html_content.replace(/(<img .*?src=)"\/(.*?)"/g, '$1"' + window.config.yihai_site + '/$2"');
                    html_content = html_content.replace(/(<source .*?src=)"\/(.*?)"/g, '$1"' + window.config.api_url + '/$2"');
                    html_content = html_content.replace(/(<video .*?src=)"\/(.*?)"/g, '$1"' + window.config.api_url + '/$2"');
                    t.wenzhang_neirong = html_content;
                })
            },
            fangan_list() {
                var t = this
                var url = window.config.api_url + '/college/application/' + t.$route.params.id
                t.axios.get(url).then(res => {
                    t.data_list = res.data
                    console.log("1212", res.data)
                    var html_content = res.data.info.content;
                    html_content = html_content.replace(/(<img .*?src=)"\/(.*?)"/g, '$1"' + window.config.yihai_site + '/$2"');
                    html_content = html_content.replace(/(<source .*?src=)"\/(.*?)"/g, '$1"' + window.config.api_url + '/$2"');
                    html_content = html_content.replace(/(<video .*?src=)"\/(.*?)"/g, '$1"' + window.config.api_url + '/$2"');
                    t.wenzhang_neirong = html_content;
                    // console.log(t.data_list)
                })
            },
            biaozhun_list() {
                var t = this
                var url = window.config.api_url + '/college/norm/' + t.$route.params.id
                t.axios.get(url).then(res => {
                    t.data_list = res.data
                    console.log("232343", res.data);
                    t.wzlx = res.data.attachment[0].name.split('.').slice(-1)[0];
                    var html_content = res.data.info.content;
                    html_content = html_content.replace(/(<img .*?src=)"\/(.*?)"/g, '$1"' + window.config.yihai_site + '/$2"');
                    html_content = html_content.replace(/(<source .*?src=)"\/(.*?)"/g, '$1"' + window.config.api_url + '/$2"');
                    html_content = html_content.replace(/(<video .*?src=)"\/(.*?)"/g, '$1"' + window.config.api_url + '/$2"');
                    t.wenzhang_neirong = html_content;
                })
            },

            yyfa_download: function () {
                var t = this;
                //todo 检测用户是否登录，以及是否购买过
                let url = window.config.api_url + '/user/application/download/' + this.$route.params.id;
                let token = localStorage.getItem('token');
                if (!token) {
                    // todo 请先登录
                }
                url += '?token=' + token;

                this.axios.get(url).then(res => {

                    if (res.data.status == 1) {
                        // todo 请重新登录
                        location.href = '/user.html#/login';
                    } else if (res.data.status == 2) {
                        location.href = '#/purchase/application/' + t.$route.params.id;
                    } else if (res.data.status == 101) {

                        location.href = '/user.html#/login';

                    } else if (!res.data.status) {

                        //todo 下载内容
                        location.href = res.data.download;
                    }

                });
                //todo 下载

            }
        },
        created: function () {
            this.init()
        },
        watch: {
            '$route'() {
                if (this.$route.params.id) {
                    // this.$router.go(0);
                    this.init()
                } else {
                    // this.$router.go(0);
                    this.init()
                }
                // 路由发生变化页面刷新
            }
        },


    }
</script>
<style>

    .html-content img{max-width:100%}

    .input2qiangzhi_buxudong111_style .uni-search-filter-row-filters .uni-search-filter-row-filter a {
        color: #FFFFFF !important;
    }

    .input2qiangzhi_buxudong111_style .el-input__inner {
        margin-left: -10px !important;
        width: 110px !important;
        height: 27px !important;
        float: left !important;
        color: #666666 !important;
        /*margin-left: 271px!important;*/
        /*margin-top: -42px!important;*/
        padding-left: 11px !important;
        border: 0px !important;
        background: #E1E1E1 !important;
        border-radius: 5px !important;
    }
</style>
<style lang="less" scoped>
    @import "../../../../node_modules/element-ui/lib/theme-chalk/display.css";

    @head_text: Source Han Sans CN;
    @font-face {

    }

    //@import "../../../assets/css/home";
    @import "../../../assets/css/home_category";
    .hallo {
        font-family: Source Han Sans CN;
    }

    @media screen and (min-width: 950px) {
        .background-title1_yingyong {
            margin-top: 30px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
            float: left;

            span {
                font-size: 16px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #4E6EF2;
                margin-left: 20px;
            }
        }

        .background-title1_liulan {
            margin-top: 30px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
            float: left;
            margin-left: 109px;

            span {
                font-size: 16px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #4E6EF2;
                margin-left: 20px;
            }
        }

        .background-title1_xiazai {
            margin-top: 30px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
            float: left;
            margin-left: 109px;

            span {
                font-size: 16px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #4E6EF2;
                margin-left: 20px;
            }
        }

        .background-title1_time {
            margin-top: 70px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;

            span {
                font-size: 16px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #4E6EF2;
                margin-left: 20px;
            }
        }
    }

    @media screen and (min-width: 700px) and (max-width: 950px) {
        .background-title1_yingyong {
            margin-top: 30px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
            float: left;

            span {
                font-size: 16px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #4E6EF2;
                margin-left: 20px;
            }
        }

        .background-title1_liulan {
            margin-top: 30px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
            float: left;
            margin-left: 109px;

            span {
                font-size: 16px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #4E6EF2;
                margin-left: 20px;
            }
        }

        .background-title1_xiazai {
            margin-top: 70px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;

            span {
                font-size: 16px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #4E6EF2;
                margin-left: 20px;
            }
        }

        .background-title1_time {
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
            float: left;
            margin-top: -25px;
            margin-left: 222px;

            span {
                font-size: 16px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #4E6EF2;
                margin-left: 20px;
            }
        }
    }

    @media screen and (max-width: 700px) {
        .background-title1_yingyong {
            margin-top: 30px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
            float: left;

            span {
                font-size: 16px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #4E6EF2;
                margin-left: 20px;
            }
        }

        .background-title1_liulan {
            margin-top: 30px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
            float: left;
            margin-left: 59px;

            span {
                font-size: 16px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #4E6EF2;
                margin-left: 20px;
            }
        }

        .background-title1_xiazai {
            margin-top: 70px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;

            span {
                font-size: 16px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #4E6EF2;
                margin-left: 20px;
            }
        }

        .background-title1_time {
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
            float: left;
            margin-top: -25px;
            margin-left: 163px;

            span {
                font-size: 16px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #4E6EF2;
                margin-left: 20px;
            }
        }
    }

</style>
<style lang="less" scoped>

    @font-face {

    }
   .aaa{
       width: 100px;
   }
    .back_jieshaoa {
        float: right;
        /*width: 96%;*/
        /*margin-left: 500px;*/

        .jieshao_fabua {
            /*width: 91px;*/
            height: 26px;
            font-size: 22px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #333333;
            line-height: 80px;
        }

        .jieshao_namea {
            //width: 325px;
            height: 25px;
            font-size: 22px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #4E6EF2;
            line-height: 80px;
        }
    }


    .main_xiangqing {
        width: 80%;
        max-width: 1200px;
        margin-right: auto;
        margin-left: auto;
        //height: 420px;
        .xiangqing_back {
            float: left;
            width: 100%;
            background: #FFFFFF;

            .back_xinxikuang {
                float: left;
                width: 96%;
                margin-left: 2%;
                margin-top: 55px;
                //height: 290px;
                background: #EEF5FD;
                border-radius: 5px;

                .xinxikuang_img {
                    float: left;
                    height: 230px;
                    margin-top: 30px;
                    margin-left: 40px;
                    margin-bottom: 30px;
                }

                .xinxikuang_text {
                    float: left;
                    margin-left: 10px;
                    //width: 383px;
                    //height: 21px;
                    font-size: 18px;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #333333;
                    line-height: 80px;
                }

                .xinxikuang_liulan {
                    float: left;
                    width: 100%;
                    margin-left: 10px;
                    //height: 18px;
                    font-size: 16px;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #4E6EF2;
                    line-height: 40px;
                }
            }

            .back_jieshao {
                float: left;
                width: 96%;
                margin-left: 2%;

                .jieshao_fabu {
                    width: 91px;
                    height: 26px;
                    font-size: 22px;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    color: #333333;
                    line-height: 80px;
                }

                .jieshao_name {
                    //width: 325px;
                    height: 25px;
                    font-size: 22px;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    color: #4E6EF2;
                    line-height: 80px;
                }

                .jieshao_time {
                    float: right;
                    //width: 80px;
                    height: 18px;
                    font-size: 15px;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #4E6EF2;
                    line-height: 100px;
                }

                .jieshao_neirong {
                    //width: 1069px;auto
                    /*width: 500px;*/
                    max-width: 50%;
                    height: auto;
                    font-size: 18px;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #333333;
                    line-height: 38px;
                }

                .jieshao_caozuo {
                    position: relative;

                    .jieshao_cash {
                        margin-left: 20%;
                        float: left;
                        width: 250px;
                        height: 85px;
                        background: #F4F4F4;
                        border-radius: 5px;
                        text-align: center;

                        .cash_img {
                            margin: 12px auto 0 auto;
                        }

                        .cash_text {
                            //width: 134px;
                            //height: 21px;
                            font-size: 18px;
                            font-family: Source Han Sans CN;
                            font-weight: 400;
                            color: #333333;
                            //line-height: 100px;
                        }
                    }

                    .caozou_xiazai {
                        float: left;
                        margin-left: 10%;
                        width: 250px;
                        height: 85px;
                        background: #4E6EF2;
                        border-radius: 5px;
                        text-align: center;

                        .xiazai_img {
                            margin: 12px auto 0 auto;
                        }

                        .xiazai_text {
                            font-size: 18px;
                            font-family: Source Han Sans CN;
                            font-weight: 400;
                            color: #FFFFFF;
                        }
                    }
                }
            }
        }

        .xiangqing_back2 {
            float: left;
            width: 100%;
            background: #FFFFFF;
            min-height: 800px;

            .back_text {
                text-align: center;
                font-size: 26px;
                font-family: Source Han Sans CN;
                font-weight: bold;
                color: #333333;
                line-height: 100px;
            }

            .back_text2 {
                text-align: center;

                .text2_biaoti {
                    //width: 91px;
                    //height: 25px;
                    font-size: 20px;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    color: #333333;
                    //line-height: 102px;
                }

                .text2_neirong {
                    //width: 325px;
                    //height: 25px;
                    font-size: 18px;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    color: #4E6EF2;
                    //line-height: 102px;
                }
            }

            .back_text3 {
                text-align: center;
                //width: 95px;
                //height: 15px;
                font-size: 18px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #4E6EF2;
                line-height: 100px;
            }

            .back_button {
                .button_zaixian {
                    margin-left: 27%;
                    float: left;
                    width: 209px;
                    height: 54px;
                    text-align: center;
                    background: #F4F4F4;
                    border-radius: 10px;
                    //width: 81px;
                    //height: 19px;
                    font-size: 20px;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #333333;
                    line-height: 54px;
                }

                .button_xiazai {
                    margin-left: 10%;
                    float: left;
                    width: 209px;
                    height: 55px;
                    background: #4E6EF2;
                    border-radius: 10px;
                    //width: 40px;
                    //height: 19px;
                    text-align: center;
                    font-size: 20px;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 55px;
                }
            }

            .fenge {
                margin-top: 40px;
                float: left;
                width: 88%;
                margin-left: 6%;
                margin-bottom: 50px;
                height: 1px;
                background: #D1D1D1;
                border-radius: 1px;
            }

            .back_neirong {
                margin-top: 20px;
                float: left;
                /*width: 88%;*/
                margin-left: 6%;
                margin-bottom: 50px;
                font-size: 22px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #333333;
                line-height: 38px;

                max-width: 50%;




            }
        }

    }
</style>
